import { render, staticRenderFns } from "./ReportingCentreDetails.vue?vue&type=template&id=58829058&"
import script from "./ReportingCentreDetails.vue?vue&type=script&lang=ts&"
export * from "./ReportingCentreDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ReportingCentreDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports